import { render, staticRenderFns } from "./contactcomposant.vue?vue&type=template&id=d22c1d4a&scoped=true&"
import script from "./contactcomposant.vue?vue&type=script&lang=js&"
export * from "./contactcomposant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22c1d4a",
  null
  
)

export default component.exports